import { MDBIcon, MDBTableHead } from "mdb-react-ui-kit";
import PropTypes from "prop-types";
import React, { useState } from "react";

export default function TableHeader(
    {
        users,
        selectedConsentFilter,
        setSelectedConsentFilter,
        selectedFilterRole,
        setSelectedFilterRole,
        sortConfig,
        setSortConfig,
    } ) {
    const [ isRoleSelectVisible, setIsRoleSelectVisible ] = useState( false );

    // Handle sort click
    const handleSort = ( key ) => {
        setSortConfig( ( prevConfig ) => {
            if ( prevConfig.key === key ) {
                return {
                    key,
                    direction: prevConfig.direction === 'ascending' ? 'descending' : 'ascending'
                };
            }
            return {
                key,
                direction: 'ascending'
            };
        } );
    };

    // Get sort icon
    const getSortIcon = ( columnKey ) => {
        if ( sortConfig.key !== columnKey ) {
            return <MDBIcon fas icon="sort" className="ms-1"/>;
        }
        return sortConfig.direction === 'ascending'
            ? <MDBIcon fas icon="sort-up" className="ms-1"/>
            : <MDBIcon fas icon="sort-down" className="ms-1"/>;
    };

    const [ isConsentFilterVisible, setIsConsentFilterVisible ] = useState( false );

    // Get unique consent statuses from users
    const consentStatuses = Array.from( new Set( users.map( user => user.consentStatus ) ) );

    const dropdownStyle = {
        position: 'absolute',
        zIndex: 1,
        bottom: '15%',
        left: '80px'
    };

    return (
        <MDBTableHead>
            <tr>
                <th onClick={ () => handleSort( 'prenom' ) }
                    style={ { cursor: 'pointer' } }>Prénom { getSortIcon( 'prenom' ) } </th>
                <th onClick={ () => handleSort( 'nom' ) }
                    style={ { cursor: 'pointer' } }>Nom { getSortIcon( 'nom' ) } </th>
                <th style={ { position: 'relative' } }>
                    <div style={ { display: 'flex', alignItems: 'center' } }>
                        <span
                            onClick={ () => handleSort( 'role' ) } style={ { cursor: 'pointer' } }
                            role="button"
                        >
                            Rôle { getSortIcon( 'role' ) }
                        </span>
                        <MDBIcon
                            fas
                            icon="filter"
                            onClick={ () => setIsRoleSelectVisible( !isRoleSelectVisible ) }
                            title="Filtrer"
                            className="ms-2"
                        />
                        { isRoleSelectVisible && (
                            <select
                                style={ dropdownStyle }
                                className='py-2'
                                value={ selectedFilterRole }
                                onChange={ ( e ) => {
                                    setSelectedFilterRole( e.target.value );
                                    setIsRoleSelectVisible( false );
                                } }
                                onBlur={ () => setIsRoleSelectVisible( false ) }
                            >
                                <option className='text-white' value="">Tous les rôles</option>
                                <option className='text-white' value="CANDIDAT">Candidat</option>
                                <option className='text-white' value="CONSULTANT">Consultant</option>
                                <option className='text-white' value="MANAGER">Manager</option>
                                <option className='text-white' value="SUPERADMIN">Super Admin</option>
                                <option className='text-white' value="CLIENT">Client</option>
                            </select>
                        ) }
                    </div>
                </th>
                <th onClick={ () => handleSort( 'email' ) } style={ { cursor: 'pointer' } }>
                    Email { getSortIcon( 'email' ) }
                </th>
                <th onClick={ () => handleSort( 'dateCreation' ) } style={ { cursor: 'pointer' } }>
                    Date de création { getSortIcon( 'dateCreation' ) }
                </th>
                <th onClick={ () => handleSort( 'dateExpiration' ) } style={ { cursor: 'pointer' } }>
                    Date de fin { getSortIcon( 'dateExpiration' ) }
                </th>
                <th style={ { position: 'relative' } }>
                    <span onClick={ () => handleSort( 'consentStatus' ) } style={ { cursor: 'pointer' } }>
                        Consentement valide { getSortIcon( 'consentStatus' ) }
                    </span>
                    <MDBIcon
                        fas
                        icon="filter"
                        title="Filtrer"
                        className="ms-2"
                        onClick={ () => setIsConsentFilterVisible( !isConsentFilterVisible ) }
                    />
                    { isConsentFilterVisible && (
                        <select
                            style={ dropdownStyle }
                            className='py-2'
                            value={ selectedConsentFilter }
                            onChange={ ( e ) => {
                                const value = e.target.value;
                                setSelectedConsentFilter( value );
                                // Close the dropdown if a specific option is selected
                                setIsConsentFilterVisible( false );
                            } }
                            onBlur={ ( e ) => e.preventDefault() }
                        >
                            <option className='text-white' value="">Tous les consentements</option>
                            { consentStatuses.map( ( status ) => (
                                <option key={ status } className='text-white' value={ status }>
                                    { status }
                                </option>
                            ) ) }
                        </select>
                    ) }
                </th>
                <th>Actions</th>
            </tr>
        </MDBTableHead>
    );
}

TableHeader.propTypes = {
    users: PropTypes.array.isRequired,
    selectedConsentFilter: PropTypes.string,
    setSelectedConsentFilter: PropTypes.func.isRequired,
    selectedFilterRole: PropTypes.string,
    setSelectedFilterRole: PropTypes.func.isRequired,
    sortConfig: PropTypes.object,
    setSortConfig: PropTypes.func.isRequired,
}